import React from 'react';
import { Box, Flex, Text, Grid } from '@chakra-ui/react';
import { CheckGreenIcon } from '@mybridge/icons';
import { isMobile } from 'react-device-detect';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';

// CalendarCard component definition
const CalendarCard = ({
  icon,
  title,
  description,
  isConnected,
  setIsopenDetailedView,
  setSelectedComponent,
  isMoible,
}) => (
  <Box
    borderWidth="1px"
    //borderRadius="md"
    borderRadius="20px"
    overflow="hidden"
    cursor="pointer"
    boxShadow="md"
    _hover={{
      boxShadow: '0px 0px 12px 0px #00000033',
    }}
    p={4}
    minW="60%"
    h="220px"
    onClick={() => {

      if (!isMoible) {
        setIsopenDetailedView(title);

      }else{
        setSelectedComponent();
      }
    }}
  >
    <Flex justifyContent="space-between" alignItems="center" my={4}>
      {icon}
      <Box fill="#127731" h="42px">
        {isConnected && (
          <Flex alignItems="center">
            <CheckGreenIcon />
            <Text fontSize="16px" color="#127731" ml={2}>
              {useTranslator().t('myCalendar.connected') || "Connected"}
            </Text>
          </Flex>
        )}
      </Box>
    </Flex>
    <Text w="full" fontWeight="medium" color="#5B5B5B" fontSize="18px">
      {title}
    </Text>
    <Text fontSize="18px" mt={4} color="#747474" noOfLines={2}
        textOverflow="ellipsis"
        title={description}>
      {description}
    </Text>
  </Box>
);

// CalendarIntegration component definition
const CalendarIntegration = ({
  setIsopenDetailedView,
  setSelectedComponent,
  calendars,
  isMoible,
}) => {
  // Check if calendars array is valid
  if (!calendars || !Array.isArray(calendars) || calendars.length === 0) {
    return (
      <Text fontSize="20px" color="red" textAlign="center" mt={8}>
        {useTranslator().t('settingsIntegration.noCalendarsAvailable') || "No calendars available to display."}
      </Text>
    );
  }

  return (
    <Grid
      pt={8}
      templateColumns={isMobile ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'}
      gap={4}
    >
      {calendars.map((calendar, index) => (
        <CalendarCard
        setSelectedComponent={()=>setSelectedComponent(calendar.key)}
          key={index}
          {...calendar}
          setIsopenDetailedView={setIsopenDetailedView}
          isMoible={isMoible}
        />
      ))}
    </Grid>
  );
};

export default CalendarIntegration;
